import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { EVERYWHERE_REGION_ID, getRegion } from '@shared/regions'
import type { RegionChangeSource } from './useHomeRegion'
import { useOncePerVisit } from './useTabVisit'

// `/discover?region=<id>` (Home forwards the older `/?region=`) is the landing link of the "Faro now covers X" push. Apply
// it once and strip it so a refresh or back-nav doesn't re-apply it over a
// region the user has since picked. Unknown ids are dropped, not stored.
export function useRegionDeepLink(setRegion: (id: string, from: RegionChangeSource) => void): void {
  const [searchParams, setSearchParams] = useSearchParams()
  const firstThisVisit = useOncePerVisit()
  useEffect(() => {
    const id = searchParams.get('region')
    if (!id || !firstThisVisit()) return
    if (id === EVERYWHERE_REGION_ID || getRegion(id)) setRegion(id, 'deep_link')
    const next = new URLSearchParams(searchParams)
    next.delete('region')
    setSearchParams(next, { replace: true })
  }, [searchParams, setSearchParams, setRegion, firstThisVisit])
}
